import React from "react";
import p1 from "../images/processes.png";
import "../style/Process.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDollar,
  faLeaf,
  faTeethOpen,
  faWandSparkles,
} from "@fortawesome/free-solid-svg-icons";

const services = [
  {
    title: "Aesthetic",
    description:
      "An invisible solution that transforms your smile without disrupting your appearance.",
    icon: <FontAwesomeIcon icon={faWandSparkles} />,
  },
  {
    title: "Convenient",
    description:
      "Unlike traditional braces, our aligners fit seamlessly into your daily routine.",
    icon: <FontAwesomeIcon icon={faTeethOpen} />,
  },
  {
    title: "Efficient",
    description:
      "Fewer doctor visits, expert-led treatment, and results you can trust.",
    icon: <FontAwesomeIcon icon={faLeaf} />,
  },
  {
    title: "Affordable",
    description:
      "A high quality smile solution at a cost that makes treatment accessible.",
    icon: <FontAwesomeIcon icon={faCommentDollar} />,
  },
];

const Process = () => {
  return (
    <>
      <section class="hero-section">
        <div class="content-container">
          <div class="text-content">
            <span class="subtitle">Excellent Choice</span>
            <h1 class="process-title">Why Choose Lamaan</h1>
            <p class="process-description">
              The perfect blend of convenience, quality, and affordability
            </p>
          </div>
          <div class="image-container">
            <img
              src={p1}
              alt="Doctor"
              style={{
                width: "80%",
                height: "100%",
              }}
            />
          </div>
        </div>
        <div className="ServicesCard-container">
          {services.map((service, index) => (
            <div className="ServicesCard-card" key={index}>
              {/* <img
                  src={service.icon}
                  alt={service.title}
                  className="ServicesCard-icon"
                /> */}
              <div className="ServicesCard-icon">{service.icon}</div>
              <h3 className="ServicesCard-title">{service.title}</h3>
              <p className="ServicesCard-description">{service.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Process;
